import { useState, useEffect } from 'react';
import Button from 'components/base/Button';
import { withTheme } from 'react-jsonschema-form';
import LayoutField from 'react-jsonschema-form-layout-2';
import Bootstrap4Theme from 'react-jsonschema-form-bs4';
import { Col, Row, Alert } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingOverlay from 'components/loading-overlay/LoadingOverlay';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { getAllDrillMakes, getDrillModel, patchDrillModel } from 'api/api';

const breadcrumbItems = [
  {
    label: 'Drill Models',
    url: '/drills/drillModels'
  },
  {
    label: 'Edit',
    active: true
  }
];

function EditDrillModel() {
  const navigate = useNavigate();
  const Form = withTheme(Bootstrap4Theme);
  const [error, setError] = useState([]);
  const [loading, setLoading] = useState(false);
  const [makeNames, setMakeNames] = useState([]);
  const [makeIds, setMakeIds] = useState([]);
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    make_id: ''
  });
  const { id } = useParams();

  useEffect(() => {
    loadMakes();
  }, []);

  useEffect(() => {
    loadData(id);
  }, [id]);

  const loadData = id => {
    setError([]);
    setLoading(true);

    getDrillModel(id)
      .then(response => {
        setFormData({
          id: response.data.data.id,
          name: response.data.data.name,
          make_id: Number(response.data.data.make.id)
        });
      })
      .catch(err => {
        try {
          setError(err.response.data.errors);
        } catch (ex) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const loadMakes = () => {
    setError([]);
    setLoading(true);

    getAllDrillMakes()
      .then(response => {
        const keys = response.data.data.map(g => g.id);
        const names = response.data.data.map(g => g.name);
        setMakeNames(names);
        setMakeIds(keys);
        console.log('keys' + JSON.stringify(keys) + JSON.stringify(names));
      })
      .catch(err => {
        try {
          setError(err.response.data.errors);
        } catch (ex) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const handleSubmit = ({ formData }) => {
    setError([]);
    setFormData(formData);
    setLoading(true);
    console.log('form data' + JSON.stringify(formData));
    patchDrillModel(formData.id, formData)
      .then(response => {
        if (response.status === 200) navigate('/drills/drillModels');
      })
      .catch(err => {
        try {
          setError(err.response.data.errors);
        } catch (error) {
          setError(['Please try again later...']);
        }
      });

    setTimeout(function () {
      setLoading(false);
    }, 1000);
  };

  const schema = {
    type: 'object',
    required: ['name', 'make_id'],
    properties: {
      name: {
        title: 'Model Name',
        type: 'string'
      },
      make_id: {
        title: 'Make',
        type: 'number',
        enum: makeIds,
        enumNames: makeNames
      }
    }
  };

  const uiSchema = {
    'ui:field': 'layout',
    name: {
      'ui:autofocus': true
    },
    make_id: {
      'ui:widget': 'select',
      'ui:placeholder': 'Select a make'
    },
    'ui:layout': [{ make_id: { md: 8 } }, { name: { md: 8 } }]
  };

  const fields = {
    layout: LayoutField
  };

  return (
    <div>
      <PageBreadcrumb items={breadcrumbItems} />
      <div className="mb-9">
        <div className="d-flex flex-wrap gap-3 flex-between-end mb-5">
          <div>
            <h2 className="mb-2">Add a Model</h2>
            <h5 className="text-700 fw-semi-bold">Add a new model</h5>
          </div>
        </div>
        <Row className="g-5">
          <Col xs={12} xl={8}>
            <div>
              <div>
                {Object.entries(error).length > 0 &&
                  error.map((e, index) => (
                    <Alert variant="soft-danger" key={index}>
                      {e}
                    </Alert>
                  ))}
              </div>

              {loading && <LoadingOverlay />}

              <Form
                schema={schema}
                uiSchema={uiSchema}
                fields={fields}
                onSubmit={handleSubmit}
                formData={formData}
                showErrorList={false}
              >
                <div
                  className="d-flex flex-wrap gap-2"
                  style={{ marginTop: '10px' }}
                >
                  <Button variant="primary" type="submit">
                    Submit
                  </Button>
                  <Button
                    variant="phoenix-secondary"
                    type="button"
                    onClick={() => navigate('/drills/drillModels')}
                  >
                    Discard
                  </Button>
                </div>
              </Form>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default EditDrillModel;
